import moment from 'moment'
import { selectEmailsCtrl } from './email_list'

userTable.$inject = [
  'filterFilter',
  'orderByFilter',
  'licenseTypes',
  'userActions',
  'domainInfo',
  '$uibModal',
  '$filter'
]
export default function userTable(
  filterFilter,
  orderByFilter,
  licenseTypes,
  userActionsService,
  domainInfo,
  $uibModal,
  $filter
) {
  return {
    restrict: 'EA',
    template: require('./_userTable.html'),
    scope: {
      userRows: '=users',
      domain: '=',
      schools: '=',
      errorMessage: '=',
      loading: '=',
      subgroups: '=',
      ui: '='
    },
    link: function(scope, elm, attrs) {
      scope.orderKey = 'tags'
      scope.reverse = false
      scope.search = ''
      scope.searchColumn = null
      scope.activeToolkitQuery = { active_only: null, type: '', sub_type: '', activated: null }
      scope.activePathwaysQuery = { active_only: null, type: '', sub_type: '', activated: null }
      scope.filteredUsers = []
      scope.licenseTypes = licenseTypes
      scope.usersPerPage = 100
      scope.shouldSortBySignUp = true

      scope.schoolOptions = []
      scope.$watch('schools', function(newSchools) {
        scope.schoolOptions = [{ uuid: '', name: '(All schools)' }].concat(newSchools || [])
      })

      scope.subgroupOptions = []
      scope.$watch('subgroups', function(newSubgroups) {
        const sortedSubgroups = (newSubgroups || []).slice().sort((a, b) => 
          (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
        );
        scope.subgroupOptions = [{ uuid: '', name: '(All subgroups)' }].concat(sortedSubgroups);
      })

      scope.tableColumnHeaders = [
        {
          attribute: 'name',
          label: 'Name'
        },
        {
          attribute: 'email',
          label: 'Email'
        },
        {
          attribute: 'title',
          label: 'Title'
        },
        {
          attribute: 'toolkit_license.type',
          label: 'Toolkit'
        },
        {
          attribute: 'toolkit_license.end_date_fmt',
          label: 'Toolkit End'
        },
        {
          attribute: 'toolkit_license.start_date_fmt',
          label: 'Toolkit Start'
        },
        {
          attribute: 'toolkit_last_active',
          label: 'Toolkit Active'
        },
        {
          attribute: 'pathways_license.type',
          label: 'Pathways'
        },
        {
          attribute: 'pathways_license.end_date_fmt',
          label: 'Pathways End'
        },
        {
          attribute: 'pathways_last_active',
          label: 'Pathways Active'
        },
        {
          attribute: 'content_profile_id',
          label: 'Content Profile'
        },
        {
          attribute: 'tags',
          label: 'Tags'
        },
        {
          attribute: 'signup_token',
          label: 'Sign-up Token'
        },
        {
          attribute: 'enforce_sso',
          label: 'Enforce SSO'
        },
        {
          attribute: 'sso_external_id',
          label: 'SSO External ID'
        },
        {
          attribute: 'account_created_at',
          label: 'Account Created'
        }
      ]

      scope.showAllColumns = function() {
        scope.tableColumnIndexHidden = new Array(scope.tableColumnHeaders.length)
      }

      let toolkitActiveIndex = 6
      let pathwaysActiveIndex = 9
      let contentProfileIndex = 10
      let ilpIndex = 12
      let ssoExternalIdIndex = 13
      let accountCreatedIndex = 15
      let toolkitLicenseStartDateIndex = 5
      
      scope.initColumnDisplay = function() {
        scope.showAllColumns()
        scope.tableColumnIndexHidden[toolkitActiveIndex] = true
        scope.tableColumnIndexHidden[pathwaysActiveIndex] = true
        scope.tableColumnIndexHidden[ilpIndex] = true
        scope.tableColumnIndexHidden[contentProfileIndex] = true
        scope.tableColumnIndexHidden[ssoExternalIdIndex] = true
        scope.tableColumnIndexHidden[accountCreatedIndex] = true
        scope.tableColumnIndexHidden[toolkitLicenseStartDateIndex] = true // toolkit start date
      }
      scope.initColumnDisplay()

      scope.$watch('userRows', function() {
        // now that the users will have all licenses, by default
        // we'll select the user's current active license
        if (angular.isArray(scope.userRows)) {
          scope.userRows.forEach(function(ur) {
            ur.pathways_license = ur.active_pathways_license
            ur.toolkit_license = ur.active_toolkit_license
          })

          // restore the users we had selected in case we want to do another action on the same people
          var selectedUuids = scope.selectedUsers.map(function(ur) {
            return ur.uuid
          })
          scope.userRows.forEach(function(ur) {
            if (selectedUuids.indexOf(ur.uuid) > -1) {
              ur.checked = true
            }
          })

          // recompute
          scope.computeSelectedUsers()
        }
      })

      scope.sort = function(key) {
        if (scope.orderKey === key) {
          scope.reverse = !scope.reverse
        } else {
          scope.reverse = false
        }
        scope.orderKey = key
      }

      scope.$watch('search', function() {
        refreshResults()
      })
      scope.$watch('searchColumn', function() {
        refreshResults()
      })
      scope.$watch('orderKey', function() {
        refreshResults()
      })
      scope.$watch('reverse', function() {
        refreshResults()
      })
      scope.$watchCollection('activeToolkitQuery', function() {
        refreshResults()
      })
      scope.$watchCollection('activePathwaysQuery', function() {
        refreshResults()
      })
      scope.$watchCollection('userRows', function(users) {
        refreshResults()
      })

      scope.setSearchColumn = function(col) {
        scope.searchColumn = col
      }

      scope.resetFilters = function() {
        scope.activeToolkitQuery = { active_only: null, type: '', sub_type: '', activated: null }
        scope.activePathwaysQuery = { active_only: null, type: '', sub_type: '', activated: null }
        scope.search = ''
        scope.searchColumn = null
      }

      function licenseActive(l) {
        return l.end_date_fmt >= moment().format('YYYY-MM-DD')
      }

      function licenseFilterFunction(product, user, lQuery) {
        var l, productLastActive
        if (product === 'toolkit') {
          l = user.active_toolkit_license
          productLastActive = user.toolkit_last_active
        }
        if (product === 'pathways') {
          l = user.active_pathways_license
          productLastActive = user.pathways_last_active
        }
        if (!l) return false

        var activeMatch = null
        if (lQuery.active_only) {
          activeMatch = licenseActive(l)
        } else if (lQuery.active_only == false) {
          activeMatch = !licenseActive(l)
        }
        let activatedMatch = null
        let now = new Date()
        let year = now.getFullYear()
        if (now.getMonth() < 7) {
          year = year - 1
        }
        let july1 = year + '-07-01'
        let july1Iso = moment(july1).toISOString()
        if (lQuery.activated) {
          activatedMatch = productLastActive && productLastActive > july1Iso
        } else if (lQuery.activated == false) {
          activatedMatch = !productLastActive || productLastActive < july1Iso
        }
        var typeMatch = true
        if (lQuery.type) {
          typeMatch = l.type === lQuery.type
        }
        var subTypeMatch = true
        if (lQuery.sub_type) {
          subTypeMatch = l.sub_type === lQuery.sub_type
        }
        return (
          (activeMatch || activeMatch === null) &&
          (activatedMatch || activatedMatch === null) &&
          typeMatch &&
          subTypeMatch
        )
      }

      function refreshResults() {
        // filter based on search bar
        if (scope.searchColumn && scope.search) {
          const keys = scope.searchColumn.attribute.split('.') // some attributes are nested keys (e.g. toolkit_license.end_date_fmt) so we need to generate a nested filter object to filter properly
          let filterObj = {}
          keys.reduce((nestedFilterObj, key, index) => {
            if (index === keys.length - 1) {
              nestedFilterObj[key] = scope.search
              return nestedFilterObj
            }
            nestedFilterObj[key] = {}
            return nestedFilterObj[key]
          }, filterObj)

          scope.filteredUsers = filterFilter(scope.userRows, filterObj)
        } else {
          scope.filteredUsers = filterFilter(scope.userRows, scope.search)
        }

        // filter based on active toolkit / active pathways
        if (
          scope.activeToolkitQuery.active_only != null ||
          scope.activeToolkitQuery.activated != null ||
          scope.activeToolkitQuery.type ||
          scope.activeToolkitQuery.sub_type
        ) {
          scope.filteredUsers = filterFilter(scope.filteredUsers, function(u) {
            return licenseFilterFunction('toolkit', u, scope.activeToolkitQuery)
          })
        }
        if (
          scope.activePathwaysQuery.active_only != null ||
          scope.activePathwaysQuery.activated != null ||
          scope.activePathwaysQuery.type ||
          scope.activePathwaysQuery.sub_type
        ) {
          scope.filteredUsers = filterFilter(scope.filteredUsers, function(u) {
            return licenseFilterFunction('pathways', u, scope.activePathwaysQuery)
          })
        }

        if (scope.shouldSortBySignUp) {
          scope.filteredUsers = orderByFilter(
            scope.filteredUsers,
            [orderBySignUpLink, scope.orderKey],
            scope.reverse
          )
        } else {
          scope.filteredUsers = orderByFilter(scope.filteredUsers, scope.orderKey, scope.reverse)
        }

        //normalize tags fields
        if (!Array.isArray(scope.filteredUsers)) {
          scope.filteredUsers = []
        }
        scope.filteredUsers = scope.filteredUsers.map(function(user) {
          if (user.tags && user.tags.length === 0) {
            user.tags = null
          }
          return user
        })
      }

      // on load and button click, order by tags with sign-up link users on top
      function orderBySignUpLink(user) {
        if (user.tags) {
          return !user.tags.includes('Sign-Up Link')
        }
      }
      scope.sortBySignUpLink = function() {
        scope.reverse = false
        scope.orderKey = 'tags'
        scope.shouldSortBySignUp = true
      }
      scope.$watchGroup(['loading', 'shouldSortBySignUp'], function() {
        if (scope.shouldSortBySignUp) {
          scope.filteredUsers = $filter('orderBy')(scope.filteredUsers, orderBySignUpLink)
        }
      })
      scope.clearSignUpLinkSort = function() {
        scope.shouldSortBySignUp = false
      }

      scope.findDuplicateEmails = function() {
        let emailsSeen = {}
        let duplicateEmails = []

        scope.userRows.forEach(ur => {
          if (emailsSeen[ur.email.toLowerCase()]) {
            duplicateEmails.push(ur.email)
          } else {
            emailsSeen[ur.email.toLowerCase()] = true
          }
        })

        if (duplicateEmails.length === 0) {
          alert('No duplicate emails found')
        } else {
          $uibModal.open({
            template:
              `<div class="modal-body">
                <p>Found ${duplicateEmails.length} duplicate emails:</p>
              <ul class="list-unstyled">` +
              duplicateEmails.map(email => `<li>${email}</li>`).join('') +
              `</ul>
              <button class="btn btn-default" ng-click="$close()">OK</button>
            </div>`
          })
        }
      }

      // checkbox selection
      scope.toggleSelectAll = function() {
        if (scope.selectAll) {
          // only select users displayed (filteredUsers)
          scope.filteredUsers.forEach(function(u) {
            u.checked = true
          })
        } else {
          // if unchecking, then we deselect ALL users (including users who are filtered out)
          scope.userRows.forEach(function(u) {
            u.checked = false
          })
        }
        scope.computeSelectedUsers()
      }

      scope.selectUsersByEmailList = async function() {
        let emails = []
        let modal = $uibModal.open({
          template: require('./_modalSelectEmails.html'),
          controller: selectEmailsCtrl,
          controllerAs: 'modalCtrl',
          resolve: {
            domainEmails: () => scope.userRows.map(ur => ur.email)
          }
        })

        try {
          emails = await modal.result
          if (!Array.isArray(emails) || emails.length === 0) {
            return
          }
          let isEmailInList = {}
          emails.forEach(email => (isEmailInList[email.toLowerCase()] = true))

          scope.filteredUsers.forEach((u, index) => {
            scope.filteredUsers[index].checked =
              scope.filteredUsers[index].checked || isEmailInList[u.email.toLowerCase()]
          })
          scope.computeSelectedUsers()
        } catch (err) {
          // User canceled the modal
        }
      }

      // store a separate array of users who have been selected
      // recompute this array on every change
      scope.selectedUsers = []
      scope.selectedUserNames = ''
      scope.toggleSelectRow = function(userRow, index, $event) {
        // check if shift was held
        if ($event.shiftKey) {
          // because of pagination, the index passed in may not match the index of the corresponding user in selectedUsers
          // users__currentPage is created by the dir-paginate directive and is set to the value of the current page
          var clickedIndex = (scope.users__currentPage - 1) * scope.usersPerPage + index
          var lo, hi
          if (scope.selectedUsers.length === 0) {
            lo = 0
            hi = clickedIndex
          } else {
            // find index of the first selected user
            var userUuids = scope.filteredUsers.map(function(u) {
              return u.uuid
            })
            var firstIndex = userUuids.indexOf(scope.selectedUsers[0].uuid)
            if (firstIndex === clickedIndex) {
              userRow.checked != userRow.checked
            } else if (firstIndex < clickedIndex) {
              lo = firstIndex
              hi = clickedIndex
            } else {
              lo = clickedIndex
              hi = firstIndex
            }
          }

          // select everything between lo and hi
          scope.filteredUsers.slice(lo, hi + 1).forEach(function(ur) {
            ur.checked = true
          })
        } else {
          userRow.checked = !userRow.checked
        }
        scope.computeSelectedUsers()
      }

      scope.clearSelection = function() {
        scope.userRows.forEach((ur, index) => {
          scope.userRows[index].checked = false
        })
        scope.computeSelectedUsers()
      }
      scope.computeSelectedUsers = function() {
        scope.selectedUsers = scope.userRows.filter(function(ur) {
          return ur.checked
        })

        // set the selectAll value accordingly
        scope.selectAll =
          scope.selectedUsers.length > 0 &&
          scope.selectedUsers.length === scope.filteredUsers.length

        scope.selectedUserNames = scope.selectedUsers
          .slice(0, 20)
          .map(function(ur) {
            return ur.name
          })
          .join('<br>')
        if (scope.selectedUsers.length > 20) {
          scope.selectedUserNames += '<br>...' + (scope.selectedUsers.length - 20) + ' more'
        }
      }

      userActionsService.populateIsAuthorized(userActionsService.actions).then(actions => {
        scope.actions = actions;
      });
      scope.performingAction = false
      scope.performAction = function(action) {
        scope.performingAction = true
        var allTags = scope.userRows.reduce((prev, next) => {
          next.tags &&
            next.tags.forEach(tag => {
              if (prev.indexOf(tag) === -1) {
                prev.push(tag)
              }
            })
          return prev
        }, [])
        userActionsService[action.key] &&
          userActionsService[action.key]({
            domain: scope.domain,
            users: scope.selectedUsers,
            allTags: allTags
          }).then(
            function(result) {
              scope.performingAction = false
              if (result) {
                if (action.key === 'addTagsToUsers' || action.key === 'removeTagsFromUsers') {
                  domainInfo.refreshUserCache({ userUuids: scope.selectedUsers.map(u => u.uuid) })
                } else {
                  domainInfo.refreshUsers()
                }
              }
            },
            function(reason) {
              if (reason) {
                alert(action.label + ' failed: ' + reason)
              }
              scope.performingAction = false
            }
          )
      }
    }
  }
}
